import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import useTranslation from 'next-translate/useTranslation';
import OpenAppBtn from '@/components/common/DownloadApp/OpenAppBtn';

// open app banner on header

interface OpenAppHeaderProps {
  openPath?: string;
  query?: { [key: string]: string };
  className?: string;
}

const OpenAppHeader: FC<OpenAppHeaderProps> = ({ openPath, query, className }) => {
  const { t, lang } = useTranslation('common');
  return (
    <div className={twMerge('max-w-[750px] mx-auto bg-surface-100-bg', className)}>
      <div className={twMerge('py-2 px-5 flex justify-between items-center flex-nowrap')}>
        <div className={twMerge('flex-1 h-8 flex justify-start items-center flex-nowrap')}>
          <div className={twMerge('flex-1 flex items-start flex-col')}>
            <div
              className={twMerge('enki-body-3xs text-surface-100-fg-default line-clamp-1')}
              dangerouslySetInnerHTML={{ __html: t('video_landing_download_title') }}
            />
          </div>
        </div>
        <OpenAppBtn openPath={openPath} query={query} />
      </div>
    </div>
  );
};

export default OpenAppHeader;
